// Estilo del panel (01/11/2026): un toque de la landing (ver Collage.js), más
// sobrio. Negro y verde de la marca, Anton en los títulos grandes y la letra de
// máquina de escribir solo en rótulos y botones. El resto, legible y limpio:
// es una herramienta de trabajo.

export const NEGRO = '#0b0b0c';
export const CREMA = '#efe6d2';
export const VERDE = '#27AE60';

export const TITULO = "font-['Anton'] uppercase tracking-[0.02em] font-normal";
export const ROTULO = "font-['Special_Elite'] uppercase tracking-[0.1em]";

// Botones redondos con borde negro y sombra corta (la de la landing, suavizada).
export const BTN_VERDE =
  "inline-flex items-center justify-center gap-2 h-10 px-5 rounded-full bg-[#27AE60] hover:bg-[#2FC06D] text-white border-2 border-[#0b0b0c] shadow-[0_2px_0_#000] font-['Special_Elite'] uppercase tracking-[0.08em] text-[13px] [text-shadow:0_1px_1px_rgba(0,0,0,0.45)] transition-colors disabled:opacity-60";
export const BTN_CLARO =
  "inline-flex items-center justify-center gap-2 h-10 px-5 rounded-full bg-white hover:bg-[#f3efe4] text-slate-800 border-2 border-[#0b0b0c] shadow-[0_2px_0_#000] font-['Special_Elite'] uppercase tracking-[0.08em] text-[13px] transition-colors disabled:opacity-60";

// Color de cada escenario del motor: la franja de la fila y el punto. Mismos
// tonos que los banners del informe (decision_presentation.py, COLORS).
const COLOR_ESCENARIO = {
  PUEDE_INICIAR: '#198754',
  APTO_PARA_EJERCICIO_MODERADO: '#c9b200',
  APTO_PARA_PROGRESAR_CON_CONTROL: '#e0a100',
  APTO_REQUERIDO: '#e07a2e',
  DERIVACION_INMEDIATA: '#c0392b',
  // Alias de registros anteriores.
  APTO_RECOMENDABLE: '#c9b200',
  APTO_PARA_PROGRESAR: '#e0a100',
};
export const COLOR_SIN_ESCENARIO = '#c9c2b2';

export const colorEscenario = (estado) => COLOR_ESCENARIO[estado] || COLOR_SIN_ESCENARIO;

// Nombre corto de cada prueba funcional, para listas.
export const NOMBRE_PRUEBA = {
  c6m: 'Caminata',
  astrand: 'Escalón',
  sentarse_pararse: 'Sentarse-pararse',
  handgrip: 'Dinamometría',
};
